import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import {
  getMemberProgress,
  checkIn,
} from "../../store/ducks/dailyCheckIn/actions";
import Swal from "sweetalert2";

class MemberProgress extends Component {
  constructor(props) {
    super(props);

    // initial values with identical data structure to the responses from GET daily_check_in/member_progress
    this.state = {
      isAuthenticated: false,
      memberProgress: {
        vipLevel: 1,
        balance: {
          credit: 0,
        },
        day: 0,
        days: Array.from({ length: 7 }).map(() => ({
          canCheckIn: false,
          isCheckedIn: false,
          requiredCredit: 0,
          rewardCredit: 0,
          rewardCoin: 0,
          rewardTotalFreeSpin: 0,
          extraRewardCredit: 0,
          extraRewardCoin: 0,
          extraRewardTotalFreeSpin: 0
        })),
      },
    };
  }

  componentDidMount() {
    // if member hasn't login, still show the Daily Check-In modal but don't check for member progress
    this.setState(
      {
        ...this.state,
        isAuthenticated: localStorage.getItem("accessToken") || false,
      },
      () => {
        if (this.state.isAuthenticated) {
          this.props.getMemberProgress();
        }
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.memberProgress !== this.props.memberProgress &&
      this.props.memberProgress &&
      this.props.memberProgress.responseCode === 200 &&
      this.props.memberProgress.data
    ) {
      this.setState({
        ...this.state,
        memberProgress: this.props.memberProgress.data,
      });
    }

    if (
      prevProps.resultCheckIn !== this.props.resultCheckIn &&
      this.props.resultCheckIn.responseCode === 200
    ) {
      const { t } = this.props;

      Swal.fire({
        icon: "success",
        title: t("global.success"),
        html: this.props.resultCheckIn.message[0],
        showConfirmButton: true,
        confirmButtonText: t("global.ok"),
      }).then(() => {
        this.props.getMemberProgress();
      });
    }
  }

  /** day must be between 0-6 */
  onCheckIn(day) {
    this.props.checkIn({ day });
  }

  render() {
    return (
      <div
        className="text-nowrap p-4"
        style={{ width: "600px", height: "550px", background: "white" }}
      >
        <h1 className="text-center">Daily Check In Progress</h1>
        <p className="text-center">Day {this.state.memberProgress.day + 1}/7</p>
        <p className="text-center">
          Balance Credit: {this.state.memberProgress.balance.credit}
        </p>
        <div className="d-flex overflow-auto" style={{ gap: "10px" }}>
          {this.state.memberProgress.days.map((day, index) => {
            const {
              canCheckIn,
              isCheckedIn,
              requiredCredit,
              rewardCredit,
              rewardCoin,
              rewardTotalFreeSpin,
              extraRewardCredit,
              extraRewardCoin,
              extraRewardTotalFreeSpin
            } = day;

            return (
              <button
                className="d-flex flex-column border p-2 text-start btn btn-primary"
                onClick={() => this.onCheckIn(index)} // this.state.memberProgress.day is one-indexed (1-7) instead of 0-6
                key={index}
                disabled={!canCheckIn}
              >
                <p>Day {index + 1}</p>
                <p>canCheckIn: {canCheckIn ? 1 : 0}</p>
                <p>isCheckedIn: {isCheckedIn ? 1 : 0}</p>
                <div className="d-flex flex-column pt-2">
                  <p>Requirements:</p>
                  <p>Credit: {requiredCredit}</p>
                </div>
                <div className="d-flex flex-column pt-2 text-start">
                  <p>Rewards:</p>
                  <p>Credit: {rewardCredit}</p>
                  <p>Coin: {rewardCoin}</p>
                  <p>Free Spin: {rewardTotalFreeSpin}</p>
                  <p>Extra Reward Credit: {extraRewardCredit}</p>
                  <p>Extra Reward Coin: {extraRewardCoin}</p>
                  <p>Extra Reward Free Spin: {extraRewardTotalFreeSpin}</p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (reduxState) => {
  return {
    memberProgress: reduxState.dailyCheckIn?.memberProgress?.data || {},
    resultCheckIn: reduxState.dailyCheckIn?.checkIn?.data || {},
  };
};

const mapDispatchToProps = {
  getMemberProgress,
  checkIn,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(MemberProgress));
